import { useCallback } from 'react';

import { useGenericSend } from '../useGenericSend';
import * as Types from './types';

export const useGetGameHistory = () => {
    const send = useGenericSend();

    return useCallback(
        async (request: Types.IGetGameHistoryRequestData): Promise<Types.IGetGameHistoryResponseData> => {
            const { data } = await send<Types.IGetGameHistoryRequestData, Types.IGetGameHistoryResponseData>({
                ID: 35702,
                responses: [35703, 35704],
                description: 'Get Game History',
                errorLevel: 1,
                ...request
            });

            return data;
        }, [
            send
        ]);
};
